import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["componentName", "_contextual", "ModalDialog", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "Transition", "rootNode"];
import { useContext } from 'react';
import memoizeOne from 'react-utils/memoizeOne';
import { SandboxContext } from '../../utils/SandboxContext';
import { FullScreen } from '../FullScreen/FullScreen';
import { ModalDialog } from '../ModalDialog/ModalDialog';
import { ResetContext } from '../../context/ResetContext';
import { jsx as _jsx } from "react/jsx-runtime";
const makeEventRelay = () => {
  const listeners = [];
  let wrappedHandler;
  const handle = evt => {
    if (typeof wrappedHandler === 'function') wrappedHandler(evt);
    listeners.forEach(listener => listener(evt));
  };
  return {
    getHandle: handler => {
      wrappedHandler = handler;
      return handle;
    },
    subscribe: listener => {
      if (listener) listeners.push(listener);
    },
    unsubscribe: listener => {
      const index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  };
};
function getTransitionProps(onOpenStart, onOpenComplete, onCloseStart, onCloseComplete) {
  return {
    onOpenStart,
    onOpenComplete,
    onCloseStart,
    onCloseComplete
  };
}
export const AbstractModal = _ref => {
  let {
      componentName,
      _contextual,
      ModalDialog: ModalDialogComponent = ModalDialog,
      onOpenStart,
      onOpenComplete,
      onCloseStart,
      onCloseComplete,
      Transition,
      rootNode
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const sandboxedContext = useContext(SandboxContext).sandboxed;
  const sandboxed = _contextual || sandboxedContext;
  const closeStartRelay = makeEventRelay();
  const openCompleteRelay = makeEventRelay();
  const memoizedGetTransitionProps = memoizeOne(getTransitionProps);
  const renderedModalDialog = /*#__PURE__*/_jsx(ResetContext, {
    children: /*#__PURE__*/_jsx(ModalDialogComponent, Object.assign({}, rest, {
      contextual: _contextual,
      _openCompleteRelay: sandboxed ? null : openCompleteRelay,
      _closeStartRelay: sandboxed ? null : closeStartRelay
    }))
  });
  return sandboxed ? renderedModalDialog : /*#__PURE__*/_jsx(FullScreen, {
    "data-layer-for": componentName,
    rootNode: rootNode,
    Transition: Transition
    // @ts-expect-error FullScreen spreads transitionProps into UILayer
    ,
    transitionProps: memoizedGetTransitionProps(onOpenStart, openCompleteRelay.getHandle(onOpenComplete), closeStartRelay.getHandle(onCloseStart), onCloseComplete),
    children: renderedModalDialog
  });
};
export default AbstractModal;